import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import useMoney from '../../../../../hooks/useMoney';
import LangEnum from '../../../../../lang/LangEnum';
import { OrderProductsTestIds } from '../../../../../utils/testIds/OrderProducts.testIds';
import { useTranslation } from '../../../../translation/TranslationContext';
import { OrderProductsMassActionsSummaryProps } from './orderProductsMassActionsSummary.types';

const OrderProductsMassActionsSummary = ({
  totalItems,
  totalPieces,
  totalValue,
}: OrderProductsMassActionsSummaryProps) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  const piecesLabel = totalPieces === 1 ? LangEnum.GLOBAL_PIECE_SINGLE : LangEnum.GLOBAL_PIECES;

  return (
    <Stack
      direction="row"
      test-id={OrderProductsTestIds.MASS_ACTIONS_SUMMARY}
      sx={{ alignItems: 'center', gap: 1, minWidth: 0 }}
    >
      <Typography variant="body2" color="primary.contrastText" noWrap>
        {translate(LangEnum.GLOBAL_ITEM, { quantity: totalItems })}
      </Typography>
      <Typography variant="body2" color="primary.contrastText" noWrap>
        {`${totalPieces} ${translate(piecesLabel)}`}
      </Typography>
      <Typography variant="body2" color="primary.contrastText" noWrap>
        {formatMoney(totalValue)}
      </Typography>
    </Stack>
  );
};

export default OrderProductsMassActionsSummary;
